// import React, { useEffect, useState } from "react";
// import { NavLink, useNavigate } from "react-router-dom";

// const PageDesignSetup = () => {
//   const navigate = useNavigate();

//   const [pageData, setPageData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Demo API response
//   // Yahan baad mein actual API call laga dena
//   useEffect(() => {
//     const response = {
//       message: "data get successfully",
//       total_pages: 1,
//       current_page: 1,
//       data: [
//         {
//           id: 3,
//           page_format: {
//             unit: "inch",
//             width: 8.5,
//             height: 11,
//             orientation: "portrait",
//           },
//           page_type_name: "Product Catalog",
//           category: [
//             { id: 1, name: "Electronics" },
//             { id: 2, name: "Clothing" },
//           ],
//           sub_category: [
//             { id: 101, name: "Mobile Phones" },
//             { id: 102, name: "Laptops" },
//           ],
//           brand: [
//             { id: 1, name: "Samsung" },
//             { id: 2, name: "Apple" },
//           ],
//           created_at: "2026-08-08T10:49:05.139733",
//           updated_at: "2026-08-08T10:49:05.139853",
//           store: 1,
//           store_name: "Technologies Aara",
//           store_email: "technologiesaara@gmail.com",
//         },
//       ],
//     };

//     setPageData(response.data);
//     setLoading(false);
//   }, []);

//   const formatDate = (date) => {
//     return new Date(date).toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   if (loading) {
//     return (
//       <div className="flex min-h-[400px] items-center justify-center">
//         <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-blue-600" />
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 p-4 md:p-6">
//       {/* Header */}
//       <div className="mb-6 flex flex-col gap-4 rounded-xl bg-white p-5 shadow-sm md:flex-row md:items-center md:justify-between">
//         <div>
//           <h1 className="text-2xl font-bold text-gray-800">
//             Page Design Setup
//           </h1>

//           <p className="mt-1 text-sm text-gray-500">
//             Manage your page formats, categories, brands and store settings.
//           </p>
//         </div>
//         {/* <button
//           type="button"
//           className="rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-blue-700"
//         >
//           + Add Page Design
//         </button> */}

//         <NavLink
//           to="/page-design-setup/add"
//           className="rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-blue-700"
//         >
//           + Add Page Design
//         </NavLink>
//       </div>

//       {/* Stats */}
//       <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
//         <div className="rounded-xl bg-white p-5 shadow-sm">
//           <p className="text-sm text-gray-500">Total Pages</p>
//           <h2 className="mt-2 text-2xl font-bold text-gray-800">
//             {pageData.length}
//           </h2>
//         </div>

//         <div className="rounded-xl bg-white p-5 shadow-sm">
//           <p className="text-sm text-gray-500">Page Type</p>
//           <h2 className="mt-2 text-lg font-bold text-gray-800">
//             {pageData[0]?.page_type_name || "-"}
//           </h2>
//         </div>

//         <div className="rounded-xl bg-white p-5 shadow-sm">
//           <p className="text-sm text-gray-500">Store</p>
//           <h2 className="mt-2 text-lg font-bold text-gray-800">
//             {pageData[0]?.store_name || "-"}
//           </h2>
//         </div>

//         <div className="rounded-xl bg-white p-5 shadow-sm">
//           <p className="text-sm text-gray-500">Format</p>
//           <h2 className="mt-2 text-lg font-bold capitalize text-gray-800">
//             {pageData[0]
//               ? `${pageData[0].page_format.width} × ${pageData[0].page_format.height} ${pageData[0].page_format.unit}`
//               : "-"}
//           </h2>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="overflow-hidden rounded-xl bg-white shadow-sm">
//         <div className="border-b border-gray-200 px-5 py-4">
//           <h2 className="font-semibold text-gray-800">Page Design List</h2>
//         </div>

//         <div className="overflow-x-auto">
//           <table className="w-full min-w-[1100px] text-left">
//             <thead className="bg-gray-50">
//               <tr className="border-b border-gray-200">
//                 <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                   ID
//                 </th>

//                 <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                   Page Type
//                 </th>

//                 <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                   Page Format
//                 </th>

//                 <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                   Categories
//                 </th>

//                 <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                   Sub Categories
//                 </th>

//                 <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                   Brands
//                 </th>

//                 <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                   Store
//                 </th>

//                 <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                   Updated
//                 </th>

//                 <th className="px-5 py-4 text-center text-xs font-semibold uppercase tracking-wide text-gray-500">
//                   Action
//                 </th>
//               </tr>
//             </thead>

//             <tbody>
//               {pageData.length > 0 ? (
//                 pageData.map((item) => (
//                   <tr
//                     key={item.id}
//                     className="border-b border-gray-100 transition hover:bg-gray-50"
//                   >
//                     {/* ID */}
//                     <td className="px-5 py-4">
//                       <span className="font-semibold text-gray-700">
//                         #{item.id}
//                       </span>
//                     </td>

//                     {/* Page Type */}
//                     <td className="px-5 py-4">
//                       <div className="font-semibold text-gray-800">
//                         {item.page_type_name}
//                       </div>

//                       <span className="mt-1 inline-flex rounded-full bg-blue-50 px-2.5 py-1 text-xs font-medium capitalize text-blue-600">
//                         {item.page_format.orientation}
//                       </span>
//                     </td>

//                     {/* Format */}
//                     <td className="px-5 py-4">
//                       <div className="font-medium text-gray-800">
//                         {item.page_format.width} × {item.page_format.height}
//                       </div>

//                       <span className="text-xs uppercase text-gray-400">
//                         {item.page_format.unit}
//                       </span>
//                     </td>

//                     {/* Categories */}
//                     <td className="px-5 py-4">
//                       <div className="flex max-w-[180px] flex-wrap gap-1.5">
//                         {item.category.map((category) => (
//                           <span
//                             key={category.id}
//                             className="rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700"
//                           >
//                             {category.name}
//                           </span>
//                         ))}
//                       </div>
//                     </td>

//                     {/* Sub Categories */}
//                     <td className="px-5 py-4">
//                       <div className="flex max-w-[180px] flex-wrap gap-1.5">
//                         {item.sub_category.map((subCategory) => (
//                           <span
//                             key={subCategory.id}
//                             className="rounded-md bg-orange-50 px-2 py-1 text-xs font-medium text-orange-700"
//                           >
//                             {subCategory.name}
//                           </span>
//                         ))}
//                       </div>
//                     </td>

//                     {/* Brands */}
//                     <td className="px-5 py-4">
//                       <div className="flex max-w-[150px] flex-wrap gap-1.5">
//                         {item.brand.map((brand) => (
//                           <span
//                             key={brand.id}
//                             className="rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700"
//                           >
//                             {brand.name}
//                           </span>
//                         ))}
//                       </div>
//                     </td>

//                     {/* Store */}
//                     <td className="px-5 py-4">
//                       <div className="font-medium text-gray-800">
//                         {item.store_name}
//                       </div>

//                       <div className="mt-1 text-xs text-gray-400">
//                         {item.store_email}
//                       </div>
//                     </td>

//                     {/* Updated */}
//                     <td className="px-5 py-4 text-sm text-gray-600">
//                       {formatDate(item.updated_at)}
//                     </td>

//                     {/* Actions */}
//                     <td className="px-5 py-4">
//                       <div className="flex items-center justify-center gap-2">
//                         <button
//                           type="button"
//                           className="rounded-lg border border-blue-200 bg-blue-50 px-3 py-2 text-xs font-semibold text-blue-600 transition hover:bg-blue-100"
//                         >
//                           View
//                         </button>

//                         {/* <button
//                           type="button"
//                           className="rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-xs font-semibold text-green-600 transition hover:bg-green-100"
//                         >
//                           Edit
//                         </button> */}
//                         <button
//                           type="button"
//                           onClick={() =>
//                             navigate(`/page-design-setup/${item.id}`, {
//                               state: {
//                                 pageData: item,
//                               },
//                             })
//                           }
//                           className="rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-xs font-semibold text-green-600 transition hover:bg-green-100"
//                         >
//                           Edit
//                         </button>

//                         <button
//                           type="button"
//                           className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs font-semibold text-red-600 transition hover:bg-red-100"
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td
//                     colSpan="9"
//                     className="px-5 py-12 text-center text-sm text-gray-500"
//                   >
//                     No page design found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PageDesignSetup;

// import React from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import { useQuery } from "react-query";
// import { getPagesD } from "../../Services/PageDesign";
// import PageDelete from "./PageDelete";

// const PageDesignSetup = () => {
//   const navigate = useNavigate();
//   const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
//   const [selectedPageId, setSelectedPageId] = React.useState(null);

//   const {
//     data: pageResponse,
//     isLoading,
//     isError,
//   } = useQuery("get-page-design", getPagesD);

//   const pageData = pageResponse?.data?.data || [];

//   const formatDate = (date) => {
//     return new Date(date).toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   if (isLoading) {
//     return (
//       <div className="flex min-h-[300px] items-center justify-center">
//         <p className="text-gray-500">Loading Page Designs...</p>
//       </div>
//     );
//   }

//   if (isError) {
//     return (
//       <div className="flex min-h-[300px] items-center justify-center">
//         <p className="text-red-500">Failed to load Page Designs.</p>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="p-5">
//         {/* Header */}
//         <div className="mb-6 flex items-center justify-between">
//           <div>
//             <h1 className="text-2xl font-semibold text-gray-800">
//               Page Design Setup
//             </h1>

//             <p className="mt-1 text-sm text-gray-500">
//               Manage your page formats, categories, brands and store settings.
//             </p>
//           </div>

//           <NavLink
//             to="/page-design-setup/add"
//             className="rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-blue-700"
//           >
//             + Add Page Design
//           </NavLink>
//         </div>

//         {/* Stats */}
//         <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
//           <div className="rounded-xl bg-white p-5 shadow-sm">
//             <p className="text-sm text-gray-500">Total Pages</p>

//             <h2 className="mt-2 text-2xl font-bold text-gray-800">
//               {pageData.length}
//             </h2>
//           </div>

//           <div className="rounded-xl bg-white p-5 shadow-sm">
//             <p className="text-sm text-gray-500">Page Type</p>

//             <h2 className="mt-2 text-lg font-bold text-gray-800">
//               {pageData[0]?.page_type_name || "-"}
//             </h2>
//           </div>

//           <div className="rounded-xl bg-white p-5 shadow-sm">
//             <p className="text-sm text-gray-500">Store</p>

//             <h2 className="mt-2 text-lg font-bold text-gray-800">
//               {pageData[0]?.store_name || "-"}
//             </h2>
//           </div>

//           <div className="rounded-xl bg-white p-5 shadow-sm">
//             <p className="text-sm text-gray-500">Format</p>

//             <h2 className="mt-2 text-lg font-bold capitalize text-gray-800">
//               {pageData[0]
//                 ? `${pageData[0].page_format.width} × ${pageData[0].page_format.height} ${pageData[0].page_format.unit}`
//                 : "-"}
//             </h2>
//           </div>
//         </div>

//         {/* Table */}
//         <div className="overflow-hidden rounded-xl bg-white shadow-sm">
//           <div className="border-b border-gray-200 px-5 py-4">
//             <h2 className="font-semibold text-gray-800">Page Design List</h2>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="w-full min-w-[1100px] text-left">
//               <thead className="bg-gray-50">
//                 <tr className="border-b border-gray-200">
//                   <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     ID
//                   </th>

//                   <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Page Type
//                   </th>

//                   <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Page Format
//                   </th>

//                   <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Categories
//                   </th>

//                   <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Sub Categories
//                   </th>

//                   <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Brands
//                   </th>

//                   <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Store
//                   </th>

//                   <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Updated
//                   </th>

//                   <th className="px-5 py-4 text-center text-xs font-semibold uppercase tracking-wide text-gray-500">
//                     Action
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {pageData.length > 0 ? (
//                   pageData.map((item) => (
//                     <tr
//                       key={item.id}
//                       className="border-b border-gray-100 transition hover:bg-gray-50"
//                     >
//                       {/* ID */}
//                       <td className="px-5 py-4">
//                         <span className="font-semibold text-gray-700">
//                           #{item.id}
//                         </span>
//                       </td>

//                       {/* Page Type */}
//                       <td className="px-5 py-4">
//                         <div className="font-semibold text-gray-800">
//                           {item.page_type_name}
//                         </div>

//                         <span className="mt-1 inline-flex rounded-full bg-blue-50 px-2.5 py-1 text-xs font-medium capitalize text-blue-600">
//                           {item.page_format?.orientation}
//                         </span>
//                       </td>

//                       {/* Format */}
//                       <td className="px-5 py-4">
//                         <div className="font-medium text-gray-800">
//                           {item.page_format?.width} × {item.page_format?.height}
//                         </div>

//                         <span className="text-xs uppercase text-gray-400">
//                           {item.page_format?.unit}
//                         </span>
//                       </td>

//                       {/* Categories */}
//                       <td className="px-5 py-4">
//                         <div className="flex max-w-[180px] flex-wrap gap-1.5">
//                           {/* {item.category?.map((category) => (
//                           <span
//                             key={category.id}
//                             className="rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700"
//                           >
//                             {category.name}
//                           </span>
//                         ))} */}
//                           {(item.category || [])
//                             .filter(Boolean)
//                             .map((category, index) => (
//                               <span
//                                 key={category?.id || index}
//                                 className="rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700"
//                               >
//                                 {category?.name || "-"}
//                               </span>
//                             ))}
//                         </div>
//                       </td>

//                       {/* Sub Categories */}
//                       <td className="px-5 py-4">
//                         <div className="flex max-w-[180px] flex-wrap gap-1.5">
//                           {/* {item.sub_category?.map((subCategory) => (
//                           <span
//                             key={subCategory.id}
//                             className="rounded-md bg-orange-50 px-2 py-1 text-xs font-medium text-orange-700"
//                           >
//                             {subCategory.name}
//                           </span>
//                         ))} */}
//                           {(item.sub_category || [])
//                             .filter(Boolean)
//                             .map((subCategory, index) => (
//                               <span
//                                 key={subCategory?.id || index}
//                                 className="rounded-md bg-orange-50 px-2 py-1 text-xs font-medium text-orange-700"
//                               >
//                                 {subCategory?.name || "-"}
//                               </span>
//                             ))}
//                         </div>
//                       </td>

//                       {/* Brands */}
//                       <td className="px-5 py-4">
//                         <div className="flex max-w-[150px] flex-wrap gap-1.5">
//                           {/* {item.brand?.map((brand) => (
//                           <span
//                             key={brand.id}
//                             className="rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700"
//                           >
//                             {brand.name}
//                           </span>
//                         ))} */}
//                           {(item.brand || [])
//                             .filter(Boolean)
//                             .map((brand, index) => (
//                               <span
//                                 key={brand?.id || index}
//                                 className="rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700"
//                               >
//                                 {brand?.name || "-"}
//                               </span>
//                             ))}
//                         </div>
//                       </td>

//                       {/* Store */}
//                       <td className="px-5 py-4">
//                         <div className="font-medium text-gray-800">
//                           {item.store_name}
//                         </div>

//                         <div className="mt-1 text-xs text-gray-400">
//                           {item.store_email}
//                         </div>
//                       </td>

//                       {/* Updated */}
//                       <td className="px-5 py-4 text-sm text-gray-600">
//                         {formatDate(item.updated_at)}
//                       </td>

//                       {/* Actions */}
//                       <td className="px-5 py-4">
//                         <div className="flex items-center justify-center gap-2">
//                           {/* <button
//                           type="button"
//                           className="rounded-lg border border-blue-200 bg-blue-50 px-3 py-2 text-xs font-semibold text-blue-600 transition hover:bg-blue-100"
//                         >
//                           View
//                         </button> */}

//                           {/* <button
//                           type="button"
//                           onClick={() =>
//                             navigate(`/page-design-setup/${item.id}`)
//                           }
//                           className="rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-xs font-semibold text-green-600 transition hover:bg-green-100"
//                         >
//                           Edit
//                         </button> */}
//                           <button
//                             type="button"
//                             onClick={() =>
//                               navigate(`/page-design-setup/${item.id}`, {
//                                 state: {
//                                   pageData: item,
//                                 },
//                               })
//                             }
//                             className="rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-xs font-semibold text-green-600 transition hover:bg-green-100"
//                           >
//                             Edit
//                           </button>

//                           {/* <button
//                           type="button"
//                           className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs font-semibold text-red-600 transition hover:bg-red-100"
//                         >
//                           Delete
//                         </button> */}
//                           <button
//                             type="button"
//                             onClick={() => {
//                               setSelectedPageId(item.id);
//                               setDeleteModalOpen(true);
//                             }}
//                             className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs font-semibold text-red-600 transition hover:bg-red-100"
//                           >
//                             Delete
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td
//                       colSpan="9"
//                       className="px-5 py-12 text-center text-sm text-gray-500"
//                     >
//                       No page design found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       <PageDelete
//         open={deleteModalOpen}
//         page_format_id={selectedPageId}
//         onClose={() => {
//           setDeleteModalOpen(false);
//           setSelectedPageId(null);
//         }}
//         onSuccess={() => {
//           setDeleteModalOpen(false);
//           setSelectedPageId(null);
//         }}
//       />
//     </>
//   );
// };

// export default PageDesignSetup;

import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { getPagesD } from "../../Services/PageDesign";
import PageDelete from "./PageDelete";

const PageDesignSetup = () => {
  const navigate = useNavigate();

  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const [selectedPageId, setSelectedPageId] = React.useState(null);
  const [sectionMenu, setSectionMenu] = React.useState(null);

  const {
    data: pageResponse,
    isLoading,
    isError,
  } = useQuery("get-page-design", getPagesD);

  const pageData = pageResponse?.data?.data || [];
  // const pageData = [...(pageResponse?.data?.data || [])].sort(
  //   (a, b) => Number(a.id) - Number(b.id),
  // );

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatSectionName = (key) => {
    if (!key) return "-";

    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  if (isLoading) {
    return (
      <div className="flex min-h-[300px] items-center justify-center">
        <p className="text-gray-500">Loading Page Designs...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex min-h-[300px] items-center justify-center">
        <p className="text-red-500">Failed to load Page Designs.</p>
      </div>
    );
  }

  return (
    <>
      <div className="mx-auto max-w-8xl p-3">
        {/* HEADER */}
        <div className="mb-2 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
          <div>
            <h1 className="text-2xl font-semibold text-gray-800">
              Page Design Setup
            </h1>

            <p className="mt-1 text-sm text-gray-500">
              Manage your page formats, categories, brands and store settings.
            </p>
          </div>

          <NavLink
            to="/page-design-setup/add"
            className="rounded-lg bg-blue-600 px-5 py-2.5 text-center text-sm font-semibold text-white transition hover:bg-blue-700"
          >
            + Add Page Design
          </NavLink>
        </div>

        {/* STATS */}
        <div className=" grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {/* <div className="rounded-xl bg-white p-5 shadow-sm">
            <p className="text-sm text-gray-500">Total Pages</p>

            <h2 className="mt-2 text-2xl font-bold text-gray-800">
              {pageData.length}
            </h2>
          </div> */}

          {/* <div className="rounded-xl bg-white p-5 shadow-sm">
            <p className="text-sm text-gray-500">Page Type</p>

            <h2 className="mt-2 text-lg font-bold capitalize text-gray-800">
              {pageData[0]?.page_type_name || "-"}
            </h2>
          </div> */}

          {/* <div className="rounded-xl bg-white p-5 shadow-sm">
            <p className="text-sm text-gray-500">Store</p>

            <h2 className="mt-2 truncate text-lg font-bold text-gray-800">
              {pageData[0]?.store_name || "-"}
            </h2>
          </div> */}

          {/* <div className="rounded-xl bg-white p-5 shadow-sm">
            <p className="text-sm text-gray-500">Sections</p>

            <h2 className="mt-2 text-lg font-bold text-gray-800">
              {pageData[0]?.page_format?.length || 0}
            </h2>
          </div> */}
        </div>

        {/* TABLE */}
        <div className="overflow-hidden rounded-xl bg-white shadow-sm">
          <div className="border-b border-gray-200 px- py-2">
            <h2 className="font-semibold text-gray-800">Page Design List</h2>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full min-w-[1100px] text-left">
              <thead className="bg-gray-50">
                <tr className="border-b border-gray-200">
                  <th className="px-5 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    ID
                  </th>

                  <th className="px-5 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Page Type
                  </th>

                  <th className="px-5 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Page Sections
                  </th>

                  {/* <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Categories
                  </th>

                  <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Sub Categories
                  </th>

                  <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Brands
                  </th> */}

                  {/* <th className="px-5 py-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Store
                  </th> */}
                  {/* <th className="px-5 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Sub manu
                  </th>
                  <th className="px-5 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Sub Sub manu
                  </th> */}

                  <th className="px-5 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Created
                  </th>

                  <th className="px-5 py-2 text-center text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {pageData.length > 0 ? (
                  pageData.map((item) => (
                    <tr
                      key={item.id}
                      className="border-b border-gray-100 transition hover:bg-gray-50"
                    >
                      {/* ID */}
                      <td className="px-5 py-2">
                        <span className="font-semibold text-gray-700">
                          #{item.id}
                        </span>
                      </td>
                      {/* PAGE TYPE */}
                      <td className="px-5 py-2">
                        <div className="font-semibold capitalize text-gray-800">
                          {item.page_type_name || "-"}
                        </div>

                        <span className="mt-1 inline-flex rounded-full bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-600">
                          {item.page_type_name === "home"
                            ? "Home"
                            : item.page_type_name === "default"
                              ? "Default"
                              : "Custom"}
                        </span>
                      </td>
                      {/* PAGE SECTIONS */}
                      <td className="px-5 py-2">
                        <button
                          type="button"
                          onClick={() =>
                            setSectionMenu(
                              sectionMenu === item.id ? null : item.id,
                            )
                          }
                          className="relative inline-flex items-center gap-2 rounded-lg border border-indigo-200 bg-indigo-50 px-4 py-2.5 text-sm font-semibold text-indigo-700 transition hover:bg-indigo-100"
                        >
                          <span>View Sections</span>

                          <span className="rounded-full bg-indigo-600 px-2 py-0.5 text-xs text-white">
                            {item.page_format?.length || 0}
                          </span>

                          <span>{sectionMenu === item.id ? "▲" : "▼"}</span>
                        </button>

                        {/* COMPLETE MENU */}
                        {sectionMenu === item.id && (
                          <div className="absolute z-50 mt-2 w-[320px] overflow-hidden rounded-xl border border-gray-200 bg-white shadow-xl">
                            <div className="border-b bg-gray-50 px-4 py-3">
                              <p className="font-semibold text-gray-800">
                                Page Sections
                              </p>

                              <p className="mt-1 text-xs text-gray-500">
                                {item.page_type_name || "Page"} sections
                              </p>
                            </div>

                            <div className="max-h-[300px] overflow-y-auto p-2">
                              {Array.isArray(item.page_format) &&
                              item.page_format.length > 0 ? (
                                item.page_format.map((format, index) => (
                                  <div
                                    key={`${format?.key}-${index}`}
                                    className="mb-1 flex items-center justify-between rounded-lg px-3 py-2 transition hover:bg-indigo-50"
                                  >
                                    <div>
                                      <p className="text-sm font-medium capitalize text-gray-800">
                                        {formatSectionName(format?.key)}
                                      </p>

                                      <p className="text-xs text-gray-400">
                                        Section
                                      </p>
                                    </div>

                                    <span className="rounded-full bg-indigo-600 px-3 py-1 text-sm font-bold text-white">
                                      {format?.value ?? 0}
                                    </span>
                                  </div>
                                ))
                              ) : (
                                <div className="px-3 py-5 text-center text-sm text-gray-400">
                                  No sections found
                                </div>
                              )}
                            </div>

                            {/* MENU FOOTER */}
                            {/* <div className="border-t bg-gray-50 p-2">
                              <button
                                type="button"
                                onClick={() => {
                                  navigate(
                                    `/page-design-setup/${item.id}`,
                                    {
                                      state: {
                                        pageData: item,
                                      },
                                    },
                                  );

                                  setSectionMenu(null);
                                }}
                                className="w-full rounded-lg bg-green-600 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-green-700"
                              >
                                Edit Page Design
                              </button>
                            </div> */}
                          </div>
                        )}
                      </td>
                      {/* CATEGORIES */}
                      {/* <td className="px-5 py-4">
                        <div className="flex max-w-[180px] flex-wrap gap-1.5">
                          {(item.category || [])
                            .filter(Boolean)
                            .map((category, index) => (
                              <span
                                key={category?.id || index}
                                className="rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700"
                              >
                                {category?.title ||
                                  category?.name ||
                                  "-"}
                              </span>
                            ))}

                          {(!item.category ||
                            item.category.length === 0) && (
                            <span className="text-sm text-gray-400">-</span>
                          )}
                        </div>
                      </td> */}
                      {/* SUB CATEGORIES */}
                      {/* <td className="px-5 py-4">
                        <div className="flex max-w-[180px] flex-wrap gap-1.5">
                          {(item.sub_category || [])
                            .filter(Boolean)
                            .map((subCategory, index) => (
                              <span
                                key={subCategory?.id || index}
                                className="rounded-md bg-orange-50 px-2 py-1 text-xs font-medium text-orange-700"
                              >
                                {subCategory?.title ||
                                  subCategory?.name ||
                                  "-"}
                              </span>
                            ))}

                          {(!item.sub_category ||
                            item.sub_category.length === 0) && (
                            <span className="text-sm text-gray-400">-</span>
                          )}
                        </div>
                      </td> */}
                      {/* BRANDS */}
                      {/* <td className="px-5 py-4">
                        <div className="flex max-w-[180px] flex-wrap gap-1.5">
                          {(item.brand || [])
                            .filter(Boolean)
                            .map((brand, index) => (
                              <span
                                key={brand?.id || index}
                                className="rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700"
                              >
                                {brand?.title || brand?.name || "-"}
                              </span>
                            ))}

                          {(!item.brand || item.brand.length === 0) && (
                            <span className="text-sm text-gray-400">-</span>
                          )}
                        </div>
                      </td> */}
                      {/* STORE */}
                      {/* <td className="px-5 py-4">
                        <div className="font-medium text-gray-800">
                          {item.store_name || "-"}
                        </div>

                        <div className="mt-1 text-xs text-gray-400">
                          {item.store_email || "-"}
                        </div>
                      </td> */}

                      {/* SAB MENU */}
                      {/* <td className="px-5 py-4">
                        <div className="flex flex-col gap-2">
                      
                          <div className="flex items-center gap-2">
                            <span className="rounded-md bg-blue-50 px-2.5 py-1 text-xs font-medium text-blue-700">
                              {item.sub_menu_name || "-"}
                            </span>
                          </div>
                        </div>
                      </td> */}
                      {/* <td className="px-5 py-4">
                        <div className="flex flex-col gap-2">
                        
                          <div className="flex items-center gap-2">
                            <span className="rounded-md bg-purple-50 px-2.5 py-1 text-xs font-medium text-purple-700">
                              {item.sub_sub_menu_name || "-"}
                            </span>
                          </div>
                        </div>
                      </td> */}

                      {/* UPDATED */}
                      <td className="px-5 py-4 text-sm text-gray-600">
                        {formatDate(item.updated_at)}
                      </td>
                      {/* ACTION */}
                      <td className="px-5 py-4">
                        <div className="flex items-center justify-center gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              navigate(`/page-design-setup/${item.id}`, {
                                state: {
                                  pageData: item,
                                },
                              })
                            }
                            className="rounded-lg border border-[#8cbae8]  px-3 py-2 text-sm font-semibold text-[#8cbae8] transition hover:bg-green-100"
                          >
                            Edit
                          </button>

                          <button
                            type="button"
                            onClick={() => {
                              setSelectedPageId(item.id);
                              setDeleteModalOpen(true);
                            }}
                            className="rounded-lg border border-red-200  px-3 py-2 text-sm font-semibold text-red-600 transition hover:bg-red-100"
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="9"
                      className="px-5 py-12 text-center text-sm text-gray-500"
                    >
                      No page design found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* DELETE MODAL */}
      <PageDelete
        open={deleteModalOpen}
        page_format_id={selectedPageId}
        onClose={() => {
          setDeleteModalOpen(false);
          setSelectedPageId(null);
        }}
        onSuccess={() => {
          setDeleteModalOpen(false);
          setSelectedPageId(null);
        }}
      />
    </>
  );
};

export default PageDesignSetup;
